import { PageId } from 'constants/pages'
import type { TPageConfig } from 'models/common.model'
import { PageIdIntlMw } from './pages'
import { HeaderId } from 'root-constants'

export const ID_TO_PAGE_CONFIG_MAP_INTL_MW: Record<PageIdIntlMw, TPageConfig> =
  {
    [PageId.ANALYZING_INTL_MW]: {
      id: PageId.ANALYZING_INTL_MW,
    },
    [PageId.START_INTL_MW]: {
      id: PageId.START_INTL_MW,
      hasHeader: true,
      headerId: HeaderId.LOGO_MENU,
      legalNotice: 'fixed',
    },
    [PageId.LIVING_UP_POTENTIAL_INTL_MW]: {
      id: PageId.LIVING_UP_POTENTIAL_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.STRUGGLE_MOST_INTL_MW]: {
      id: PageId.STRUGGLE_MOST_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.STUCK_AREAS_INTL_MW]: {
      id: PageId.STUCK_AREAS_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.REASON_TO_START_INTL_MW]: {
      id: PageId.REASON_TO_START_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.GOOD_COMPANY_INTL_MW]: {
      id: PageId.GOOD_COMPANY_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.LITTLE_INTEREST_INTL_MW]: {
      id: PageId.LITTLE_INTEREST_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.EMOTION_SHIFTS_INTL_MW]: {
      id: PageId.EMOTION_SHIFTS_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.CALM_DOWN_INTL_MW]: {
      id: PageId.CALM_DOWN_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.RECHARGING_INTL_MW]: {
      id: PageId.RECHARGING_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.ACCEPT_COMPLIMENTS_INTL_MW]: {
      id: PageId.ACCEPT_COMPLIMENTS_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.PRIORITIZE_OTHERS_INTL_MW]: {
      id: PageId.PRIORITIZE_OTHERS_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.LEAN_ON_SOMEONE_INTL_MW]: {
      id: PageId.LEAN_ON_SOMEONE_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.UNDERSTOOD_BY_OTHERS_INTL_MW]: {
      id: PageId.UNDERSTOOD_BY_OTHERS_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.WE_FEEL_YOU_INTL_MW]: {
      id: PageId.WE_FEEL_YOU_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.OVERTHINKING_DECISIONS_INTL_MW]: {
      id: PageId.OVERTHINKING_DECISIONS_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.AUTOPILOT_INTL_MW]: {
      id: PageId.AUTOPILOT_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.UNABLE_TO_START_INTL_MW]: {
      id: PageId.UNABLE_TO_START_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.DISTRACTIONS_INTL_MW]: {
      id: PageId.DISTRACTIONS_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.MEANING_TO_DO_INTL_MW]: {
      id: PageId.MEANING_TO_DO_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.OTHER_SIDE_INTL_MW]: {
      id: PageId.OTHER_SIDE_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.GENUINE_STRENGTHS_INTL_MW]: {
      id: PageId.GENUINE_STRENGTHS_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      headerId: HeaderId.BACK_LOGO_MENU,
      progressBar: 'controlled',
    },
    [PageId.TIME_INVESTMENT_INTL_MW]: {
      id: PageId.TIME_INVESTMENT_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      headerId: HeaderId.BACK_LOGO_MENU,
      progressBar: 'controlled',
    },
    [PageId.HEAR_ABOUT_US_INTL_MW]: {
      id: PageId.HEAR_ABOUT_US_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      headerId: HeaderId.BACK_LOGO_MENU,
      progressBar: 'controlled',
    },
    [PageId.PREPARE_FLOW_INTL_MW]: {
      id: PageId.PREPARE_FLOW_INTL_MW,
      hasHeader: true,
      headerId: HeaderId.LOGO_ONLY,
    },
    [PageId.PATTERNS_IMPACT_INTL_MW]: {
      id: PageId.PATTERNS_IMPACT_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.EMAIL_INTL_MW]: {
      id: PageId.EMAIL_INTL_MW,
      hasHeader: true,
      hasHeaderBackButton: true,
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.OFFER_INTL_MW]: {
      id: PageId.OFFER_INTL_MW,
    },
    [PageId.SPECIAL_DISCOUNT_INTL_MW]: {
      id: PageId.SPECIAL_DISCOUNT_INTL_MW,
      hasHeader: true,
      headerId: HeaderId.LOGO_MENU,
    },
    [PageId.CANCEL_OFFER_INTL_MW]: {
      id: PageId.CANCEL_OFFER_INTL_MW,
    },
    [PageId.PAYMENT_INTL_MW]: {
      id: PageId.PAYMENT_INTL_MW,
    },
    [PageId.REGISTRATION_INTL_MW]: {
      id: PageId.REGISTRATION_INTL_MW,
      hasHeader: true,
      headerId: HeaderId.POLICY,
    },
    [PageId.NAME_ENTRY_INTL_MW]: {
      id: PageId.NAME_ENTRY_INTL_MW,
      hasHeader: true,
      headerId: HeaderId.POLICY,
    },
    [PageId.REPORT_INTL_MW]: {
      id: PageId.REPORT_INTL_MW,
      hasHeader: true,
      headerId: HeaderId.LOGO_MENU,
    },
  }
